export default __webpack_public_path__ + "static/media/Pretendard-Regular.subset.e17e49fe.woff";